var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.8338 4.08362L7.58863 7.42404C7.41064 7.5274 7.20846 7.58185 7.00263 7.58185C6.79679 7.58185 6.59461 7.5274 6.41662 7.42404L1.1662 4.08362M2.33296 2.3338H11.667C12.3114 2.3338 12.8338 2.85608 12.8338 3.50035V10.4996C12.8338 11.1439 12.3114 11.6662 11.667 11.6662H2.33296C1.68858 11.6662 1.1662 11.1439 1.1662 10.4996V3.50035C1.1662 2.85608 1.68858 2.3338 2.33296 2.3338Z",
    stroke: "#60A5FA",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.1d754224c75e2d43a4a6c09e640eb802.svg";
export { ForwardRef as ReactComponent };